/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChannelFilterViewModel } from "../types/ChannelFilterViewModel.ts";

export const channelFilterViewModelSchema = z.object({
  search: z
    .string()
    .describe(
      "Texto livre aplicado ao nome do canal e ao ID do vídeo no Vimeo. Opcional.",
    )
    .nullish(),
  active: z
    .boolean()
    .default(true)
    .describe(
      "Filtra por situação do canal. Vem ligado por padrão, reproduzindo o filtro que no legado existia apenas no grid. Informe nulo para trazer ativos e inativos.",
    )
    .nullish(),
  pageNumber: z.optional(
    z.number().int().default(1).describe("Página da listagem. Mínimo 1."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  ),
}) as unknown as ToZod<ChannelFilterViewModel>;
